import type { UsageAction } from "../../usage/events";
import type { Tracker } from "./usage";

/** The one live tracker (set by Shell for owner sessions). Every call here never throws. */
let current: Tracker | null = null;

/** Calls made before a tracker exists (a child page's effect runs before Shell sets it); only the latest are kept. */
const MAX_BUFFERED = 20;
let buffered: ((t: Tracker) => void)[] = [];

function run(call: (t: Tracker) => void): void {
  if (current) {
    try { call(current); } catch { /* tracking never affects the app */ }
    return;
  }
  buffered.push(call);
  if (buffered.length > MAX_BUFFERED) buffered.shift();
}

export function setUsageTracker(t: Tracker | null): void {
  current = t;
  const pending = buffered;
  buffered = [];
  if (!t) return;
  for (const call of pending) {
    try { call(t); } catch { /* tracking never affects the app */ }
  }
}

export function trackAction(name: UsageAction, props?: Record<string, string | number | boolean>): void {
  run((t) => t.action(name, props));
}

export function trackPageView(pathname: string): void {
  run((t) => t.pageView(pathname));
}
